module.exports = __webpack_public_path__ + "img/IMG_7204.fa19f39e.webp";